<div class="">
  <re-captcha
    id="recaptcha"
    [siteKey]="siteKey"
    (resolved)="handleCaptchaResolved($event)"
    (errored)="handleCaptchaError()"
    size="invisible"
    #invisible>
  </re-captcha>
</div>